import React from 'react'

function SupplyChainWeOffer() {
   return (
      <section className="container-fluid section_primary_bg industries-bg-image">
         <div className="container text-center mb-4 innovation_comman blockchain_innovation">
            <h2 className="tech_title section_heading_title mb-2">
               Supply Chain & Logistics Software Features We Offer
            </h2>
            <p className="sub_body">
               As pioneers in real estate app development, we create scalable
               and feature-rich solutions designed to enhance user engagement
               and drive business growth. Our applications stand out with
               advanced functionalities that ensure seamless property search and
               management experiences.
            </p>
         </div>

         <div className="container text-center">
            <div className="innovation_card_main blockchain_innovation_card_main industry_web_new">
               <div className="row g-4 industry-grid travel-tourism-wrap">
                  <div className="col-lg-4 col-md-6 industry-card-wrapper line-before">
                     <div className="industry-card">
                        <div className="icon-circle">
                           <img
                              src="/assets/svg/industries/supplychain/c1.svg"
                              alt="Health Icon"
                           />
                        </div>
                        <h3 className="industry-subtitle fw-semibold">
                           Real-Time Shipment Tracking
                        </h3>
                        <p className="industry-description">
                           Our live tracking functionality allows you to make dynamic changes
                           to delivery routes, track performance metrics, and make efficient
                           use of resources. This makes for quicker deliveries, higher
                           precision, and sounder business decisions using real-time insights.
                        </p>
                     </div>
                  </div>

                  <div className="col-lg-4 col-md-6 industry-card-wrapper line-before">
                     <div className="industry-card">
                        <div className="icon-circle">
                           <img
                              src="/assets/svg/industries/supplychain/c2.svg"
                              alt="Fintech Icon"
                           />
                        </div>
                        <h4 className="industry-subtitle fw-semibold">
                           Smart Route Optimization
                        </h4>
                        <p className="industry-description">
                           Advanced algorithms are applied to calculate optimal shipping
                           routes. This minimizes fuel usage, decreases delivery times, and
                           reduces operating expenses, allowing you to enhance productivity
                           and optimize profits.
                        </p>
                     </div>
                  </div>

                  <div className="col-lg-4 col-md-6 industry-card-wrapper line-before">
                     <div className="industry-card">
                        <div className="icon-circle">
                           <img
                              src="/assets/svg/industries/supplychain/c3.svg"
                              alt="Logistics Icon"
                           />
                        </div>
                        <h4 className="industry-subtitle fw-semibold">
                           Automated Dispatching & Scheduling
                        </h4>
                        <p className="industry-description">
                           Eliminate human mistakes and optimize logistics operations with
                           auto-dispatching. Easily assign drivers, manage deliveries, and track
                           vehicle fleets with accuracy, delivering on-time and error-free
                           shipments.
                        </p>
                     </div>
                  </div>

                  <div className="col-lg-4 col-md-6 industry-card-wrapper">
                     <div className="industry-card">
                        <div className="icon-circle">
                           <img
                              src="/assets/svg/industries/supplychain/c4.svg"
                              alt="Ecommerce Icon"
                           />
                        </div>
                        <h4 className="industry-subtitle fw-semibold">
                           Advanced Inventory Management
                        </h4>
                        <p className="industry-description">
                           Smart inventory management allows you to boost supply chain
                           efficiency. Real-time stock tracking combined with automatic
                           restocking alerts and the elimination of stock shortages enables clean
                           warehouse operations.
                        </p>
                     </div>
                  </div>

                  <div className="col-lg-4 col-md-6 industry-card-wrapper">
                     <div className="industry-card">
                        <div className="icon-circle">
                           <img
                              src="/assets/svg/industries/supplychain/c5.svg"
                              alt="Real Estate Icon"
                           />
                        </div>
                        <h4 className="industry-subtitle fw-semibold">
                           Data Security & Compliance
                        </h4>
                        <p className="industry-description">
                           We put data protection first by using encryption, access controls,
                           and regulatory compliance. Our software keeps your sensitive
                           logistics information secure and up to industry standards.
                        </p>
                     </div>
                  </div>

                  <div className="col-lg-4 col-md-6 industry-card-wrapper">
                     <div className="industry-card">
                        <div className="icon-circle">
                           <img
                              src="/assets/svg/industries/supplychain/c6.svg"
                              alt="Gaming Icon"
                           />
                        </div>
                        <h4 className="industry-subtitle fw-semibold">
                           Customizable Analytics Dashboards
                        </h4>
                        <p className="industry-description">
                           Obtain strong insights through dashboard interactive capabilities.
                           Our dashboards allow configurable visualization of live analytics which
                           enables you to make data-based choices and monitor performance while
                           discovering enhancement opportunities.
                        </p>
                     </div>
                  </div>
               </div>
            </div>
         </div>

      </section>
   )
}

export default SupplyChainWeOffer
